<template>
  <div class="dropdown-editor center-ag-grid-editor" :style="{ '--cell-width': cellWidth + 'px' }">
    <RDropdown
      ref="dropdown"
      :value="model"
      no-label
      no-hint
      :options="options"
      :option-label="optionLabel"
      :option-value="optionValue"
      :multiple="multiple"
      :emit-value="emitValue"
      :map-options="mapOptions"
      :with-n-a="withNA"
      @popup-show="onPopupShow"
      @input="onInput"
      @keydown.enter="onEnter"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    model: null,
    cellWidth: 0,
    enterPressed: false
  }),

  computed: {
    multiple() {
      return !!this.params.multiple
    },

    emitValue() {
      return !!this.params.emitValue
    },

    mapOptions() {
      return !!this.params.mapOptions
    },

    withNA() {
      return !!this.params.withNA
    },

    options() {
      if (this.params.options) return this.params.options

      const optionsModule = this.params.optionsModule
      const optionsState = this.params.optionsState

      return this.$store.state[optionsModule][optionsState]
    },

    optionLabel() {
      if (this.params.optionLabel) return this.params.optionLabel
      return 'label'
    },

    optionValue() {
      if (this.params.optionValue) return this.params.optionValue
      return 'value'
    }
  },

  created() {
    if (this.params.initialValue) this.model = this.params.initialValue
    else this.model = this.params.value
  },

  mounted() {
    this.observeAndSetDimensionsOfCell()
    this.$nextTick(() => this.$refs.dropdown.$refs.select.showPopup())
  },

  methods: {
    getValue() {
      if (this.params.getValue) return this.params.getValue(this.model)
      return this.model
    },

    isPopup() {
      return true
    },

    observeAndSetDimensionsOfCell() {
      const colId = this.params.column.colId
      const el = document.querySelector(`.ag-cell[col-id="${colId}"]`)
      const observer = new ResizeObserver(entries => {
        entries.forEach(entry => (this.cellWidth = entry.borderBoxSize[0].inlineSize))
      })

      observer.observe(el)
      this.$once('beforeDestroy', () => observer.unobserve(el))
    },

    onPopupShow() {
      this.$nextTick(() => {
        const qMenu = document.querySelector('.q-menu')
        qMenu.remove()
        this.$el.appendChild(qMenu)
      })
    },

    onInput(newVal) {
      if (this.enterPressed) return
      this.model = newVal
      if (!this.multiple) this.params.api.stopEditing()
    },

    onEnter() {
      this.params.api.stopEditing()
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-editor {
  width: var(--cell-width);
  height: 50px;

  .r-dropdown {
    width: 100%;
  }
}
</style>

<style lang="scss">
.ag-popup-editor {
  box-shadow: none !important;
}
</style>
